import { type Middleware } from "redux";
import {
    type ApplicationEventsFromRedux,
    supportedApplicationEventsFromRedux,
} from "./ApplicationEvents";
import { getApplicationManager } from "./ApplicationUtilities";

class ReduxApplicationBridge {
    public handle(type: ApplicationEventsFromRedux, action: unknown): void {
        getApplicationManager().send(type, action, undefined, 1);
    }
}

export const reduxApplicationBridge = new ReduxApplicationBridge();

export const applicationBridgeMiddleware: Middleware = () => next => action => {
    const result = next(action);

    if(supportedApplicationEventsFromRedux.includes(action.type)) {
        reduxApplicationBridge.handle(action.type, action);
    }

    return result;
};
